export const UPLOAD_UNIVERSITY_IMAGE_REQ = "UPLOAD_UNIVERSITY_IMAGE_REQ";
export const UPLOAD_UNIVERSITY_IMAGE_SUCCESS =
  "UPLOAD_UNIVERSITY_IMAGE_SUCCESS";
export const UPLOAD_UNIVERSITY_IMAGE_FAILED = "UPLOAD_UNIVERSITY_IMAGE_FAILED";
export const UPLOAD_UNIVERSITY_IMAGE_RESET = "UPLOAD_UNIVERSITY_IMAGE_RESET";

export const UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ =
  "UNIVERSITY_IMAGE_AC_IMAGE_TYPE_REQ";
export const UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS =
  "UNIVERSITY_IMAGE_AC_IMAGE_TYPE_SUCCESS";
export const UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED =
  "UNIVERSITY_IMAGE_AC_IMAGE_TYPE_FAILED";
export const UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET =
  "UNIVERSITY_IMAGE_AC_IMAGE_TYPE_RESET";
